import { ITranslations } from 'types/common';
import { ReviewsTransFields } from './types';
import en from 'translations/en/reviews.json';
import pl from 'translations/pl/reviews.json';
import sl from 'translations/sl/reviews.json';

export const reviewsTranslations: ITranslations<ReviewsTransFields> = {
  name: 'reviews',
  en,
  pl,
  sl,
};
